import { queryOptions } from '@tanstack/react-query';
import { type AccommodationTypeName } from 'src/types/accommodationTypes';

import rtwClient from '../apiService';

import TaskService from './taskService';

// **** Queries **** //

export const getTaskQueryOptions = {
  nonPhysicalTasks: () =>
    queryOptions({
      queryKey: ['nonPhysicalTasks'] as const,
      queryFn: () => TaskService.fetchNonPhysicalTasks(),
    }),
  nonPhysicalTasksByRegion: (regionId: number, accommodationType: string) =>
    queryOptions({
      queryKey: ['nonPhysicalTasks', 'regions', regionId, accommodationType] as const,
      queryFn: () => TaskService.fetchNonPhysicalTasksByRegion(regionId, accommodationType as AccommodationTypeName),
    }),
  regionTaskGroups: (regionId: number) =>
    queryOptions({
      queryKey: ['regionTaskGroups', regionId],
      queryFn: () => TaskService.getRegionGroupsAndTasksByRegionId(regionId, rtwClient),
    }),
  regionTasks: (regionId: number) =>
    queryOptions({
      queryKey: ['regionTasks', regionId],
      queryFn: () => TaskService.fetchRegionTasksByRegionId(regionId, rtwClient),
    }),
};

// **** Mutations **** //

export const getTaskMutationOptions = {
  regionTasks: {
    update: () => ({
      mutationFn: TaskService.updateRegionTasks,
      meta: {
        invalidates: [['regionTaskGroups']],
        successMessage: 'Updated region tasks and/or taskGroups successfully',
      },
    }),
  },
  restrictionForm: {
    update: () => ({
      mutationFn: TaskService.updateRestrictionForm,
      meta: {
        successMessage: 'Updated restriction form successfully',
      },
    }),
  },
  nonPhysicalTasks: {
    create: () => ({
      mutationFn: TaskService.createNonPhysicalTask,
      meta: {
        invalidates: [getTaskQueryOptions.nonPhysicalTasks().queryKey],
        successMessage: 'Created Non-Physical Task successfully',
      },
    }),
    update: () => ({
      mutationFn: TaskService.updateNonPhysicalTask,
      meta: {
        invalidates: [getTaskQueryOptions.nonPhysicalTasks().queryKey],
        successMessage: 'Saved Non-Physical Task successfully',
      },
    }),
    delete: () => ({
      mutationFn: TaskService.deleteNonPhysicalTask,
      meta: {
        invalidates: [getTaskQueryOptions.nonPhysicalTasks().queryKey],
        successMessage: 'Deleted Non-Physical Task successfully',
      },
    }),
  },
};
